// removed by extract-text-webpack-plugin
module.exports = {"red":"#e40000","yellow":"#fdc400","orange":"#ef8d07","lime":"#d3d000","dark-green":"#008300","dark-red":"#a30000","container":"Ptn4JhdErASVxUTNS6-JX","meter":"_389xqgpqVu-NjmU-GI1jOM","description":"_7vYfm3CHINrsXYGdCFt_q","weak":"_2qtAuujhthZV2KeHgr-rhb","fair":"_2ob19XCszvt80Nu5OMU5uw","strong":"wvZ3QKw-EziSKZaU-ikqh","hasStrongPassword":"_1AUNV0j1wUb5U56GGUVoMD"};


//////////////////
// WEBPACK FOOTER
// ./src/uis/common/Error/PasswordStrengthMeter.css
// module id = 938
// module chunks = 0